import { createModel } from "xstate/lib/model";
import { IServiceStatus } from "@nju/data-access-portal-product";
import { changeSubscriptionStatus } from "@nju/data-access-portal-service";
import { BasicError, isOk } from "@nju/result";

interface IContext {
  productId?: string;
  currentStatus?: IServiceStatus["fSecureServiceStatus"] | "AlmostTerminated";
}

type IEvent =
  | { type: "SUBSCRIBE"; currentStatus: IServiceStatus["ftthServiceStatus"] }
  | { type: "SUBSCRIBE_SUCCESS" }
  | { type: "SUBSCRIBE_EXPIRED" }
  | { type: "SUBSCRIBE_ERROR" };

const model = createModel<IContext, IEvent>({});

const setCurrentStatus = model.assign(({ currentStatus }) => {
  return {
    currentStatus,
  };
}, "SUBSCRIBE");

export const fSecureServiceCTABannerMachine = model.createMachine(
  {
    initial: "idle",
    states: {
      idle: {
        id: "idle",
        on: {
          SUBSCRIBE: {
            actions: setCurrentStatus,
            target: "subscribe",
          },
        },
      },
      subscribe: {
        invoke: {
          src: "changeSubscriptionStatus",
        },
        on: {
          SUBSCRIBE_SUCCESS: {
            actions: "onSubscribeSuccess",
            type: "final",
          },
          SUBSCRIBE_ERROR: "error",
          SUBSCRIBE_EXPIRED: "error",
        },
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      changeSubscriptionStatus: ({ productId, currentStatus }) => {
        return async (callback) => {
          if (!productId || !currentStatus) {
            throw new BasicError({ message: "Missing required fields" });
          }

          const result = await changeSubscriptionStatus(productId, {
            oldStatus: currentStatus,
            newStatus: "Active",
          });

          if (isOk(result)) {
            callback({ type: "SUBSCRIBE_SUCCESS" });
          } else {
            if (result.err.code === "UNSUBSCRIBE_TIME_EXPIRED") {
              callback({ type: "SUBSCRIBE_EXPIRED" });
            } else {
              callback({ type: "SUBSCRIBE_ERROR" });
            }
          }
        };
      },
    },
  },
);
